'use strict';

/** @type {import('./max')} */
module.exports = Math.max;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/math-intrinsics/max.js
// module id = ../../../../math-intrinsics/max.js
// module chunks = 5